import React from 'react'
import { useTranslation } from 'react-i18next'

const Navbar = ({title}) => {
const { t: trans, i18n } = useTranslation(['mobileCommon', 'test'])
  return (
    <section className="cart  h-full  ">
        <div className=" bg-black text-white">
          <div className="job-header pb-10 pt-10 pr-20 pl-10">
            <img src="/assets/logo/logo-full.png" alt="discount" className="pl-10 pr-10 " />

            <h2 className="text-40 pr-10 pl-10 text-white text-center font-bold nice-apply-theme text-capitalize">
              {title}
            </h2>

            <div
              className={'change-lang  text-bold text-24 pl-20 pr-10'}
              onClick={() => {
                var bb =
                  window.location.pathname.includes('/en') ||
                  window.location.pathname.includes('/ar')
                    ? window.location.href.replace(
                        /en|ar/,
                        trans('mobileCommon:changeLangCode'),
                      )
                    : window.location.origin +
                      '/' +
                      trans('mobileCommon:changeLangCode') +
                      window.location.pathname
                console.log('......:', bb)
                window.location = bb
              }}
            >
              {trans('mobileCommon:changeLang')}
            </div>
          </div>
        </div>
    
      </section> 
  )
}

export default Navbar